export const ROUTE_PATH = '/cars';

export const FEATURE_NAME = 'carListPage';
